var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-content"},[_c('dashboard-content-nav',{attrs:{"nav":_vm.navItems}}),_c('keep-alive',[_c(_vm.currentComponent,{tag:"component",attrs:{"entity_index":_vm.entity_index}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }